module.exports = __webpack_public_path__ + "7f0fe06a133510339cff928d35e498d1.md";